import logger from "../../../lib/logger";
import { getServiceBanner } from "../../../lib/api/serviceBanner";
import { receiveServiceBanner } from "./";

export const fetchServiceBanner =
  ({ country, uuid, xSiteOrigin }) =>
  (dispatch) => {
    dispatch(receiveServiceBanner(null));

    return getServiceBanner({ country, uuid, xSiteOrigin })
      .then(({ serviceBanner }) => {
        dispatch(receiveServiceBanner(serviceBanner));
      })
      .catch((error) => {
        error.message = `getServiceBanner failed, and caught error: ${error.message}`;
        logger.error(error);
      });
  };
